export default defineNuxtRouteMiddleware(async () => {
  const { data, status, signOut } = useAuth();
  const role = data.value?.role

  // An authenticated non-นายหน้า is a state the backend can no longer produce:
  // the BFF's login role gate (plan-fix-liff-role-gate) answers 403 for every
  // role outside {freelance, company}. Reaching here therefore means a stale
  // `auth:token` minted before that gate existed — so end the session instead
  // of bouncing to /property-owner. That bounce stranded the user with no way
  // out: the logout button lives in App/Header, which only layouts/default
  // renders, every agent page is guarded by this very middleware, and
  // /auth/login is unauthenticatedOnly — so every route looped back here.
  //
  // `role` must be KNOWN before acting. While the session is still loading,
  // status is already 'authenticated' while data.value is null; signing a real
  // นายหน้า out on that race would be worse than the old redirect, so an
  // unknown role now does nothing instead of redirecting.
  if (status.value === 'authenticated' && role && role !== 'นายหน้าอิสระ' && role !== 'นายหน้าบริษัท') {
    try {
      await signOut({ callbackUrl: '/auth/login' })
    } catch {
      // signOut POSTs to the BFF, which 401s on an already-expired token. Clear
      // the cookie ourselves so the user still escapes — the same recovery
      // owner-permission.ts performs when it finds an expired owner token.
      useCookie('auth:token').value = null
      return navigateTo('/auth/login')
    }
  }
})
